// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsergroupAddOutlinedSvg from "@fishx/icons-svg/es/asn/UsergroupAddOutlined";
import FishxIcon from '../components/FishxIcon';

var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupAddOutlinedSvg
  }));
};

UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
export default React.forwardRef(UsergroupAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UsergroupAddOutlined.js
// module id = 4356
// module chunks = 0